export const initialSettings = {
    theme: 'light',
    language: 'en',
    notificationsEnabled: true,
    // Add other general or app-specific settings here
  };
  
  const settingsReducer = (state, action) => {
    switch (action.type) {
      case 'UPDATE_SETTING':
        if (action.payload && typeof action.payload.key === 'string') {
          return {
            ...state,
            [action.payload.key]: action.payload.value,
          };
        }
        console.warn('UPDATE_SETTING action dispatched without proper payload (key/value).');
        return state;
      case 'UPDATE_MULTIPLE_SETTINGS': // New action type for batch updates
        if (typeof action.payload === 'object' && action.payload !== null) {
          return {
            ...state,
            ...action.payload, // Merge the updates
          };
        }
        console.warn('UPDATE_MULTIPLE_SETTINGS action dispatched with invalid payload.');
        return state;
      case 'REPLACE_SETTINGS': // This replaces the entire settings object
        // Ensure all keys from initialSettings are present, overlay with payload
        return { ...initialSettings, ...action.payload };
      case 'RESET_SETTINGS':
        return { ...initialSettings };
      default:
        return state;
    }
  };
  
  export default settingsReducer;